import React from 'react';
import PropTypes from 'prop-types';

const Loading = props => {

    const { height, urlCommonAssets2 } = props;

    return (
        <article className={`${height} d-flex align-items-center justify-content-center`}>
            <img className="img-fluid" src={`${urlCommonAssets2}img/loading-brand.gif`} alt="Cargando"/>
        </article>        
    )
}

export default Loading;

Loading.propTypes = {
    height: PropTypes.string.isRequired,
    urlCommonAssets2: PropTypes.string.isRequired
}